import LoginPage from "./loginPage";

export { LoginPage };
